import { call, put } from "redux-saga/effects"
import { push } from 'connected-react-router'
import { Modal } from 'antd'
import axios from 'axios'
import config from '../config'

import { 
    fetchNewsSuccess,fetchNewsFailed,
} from "../actions/news"


import { resetAuth } from "../actions/auth"

export function* fetchNews(action) {
    const id = action.payload
    const url = config.API_URL+`/news/${id}`
    try {
        const response = yield axios({
            method: 'get',
            url: url,
        })
        if(response.data.successful){
            yield put(fetchNewsSuccess(response.data.news))
        }
    }catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status === 401){
                yield put(resetAuth())
            }
        }
        yield put(fetchNewsFailed(message))
    }
}
